import { render, staticRenderFns } from "./UsePoint.vue?vue&type=template&id=3951f12e&scoped=true"
import script from "./UsePoint.vue?vue&type=script&lang=js"
export * from "./UsePoint.vue?vue&type=script&lang=js"
import style0 from "./UsePoint.vue?vue&type=style&index=0&id=3951f12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951f12e",
  null
  
)

export default component.exports